import React from "react";

const FooterVisualizacao = ({ onVoltar }) => {
  return (
    <div className="footer-dependente p-3">
      <button
        type="button"
        className="btn btn-outline-dark"
        onClick={onVoltar}
      >
        <i className="fas fa-arrow-left me-2" />
        Voltar à Lista
      </button>
    </div>
  );
};

export default FooterVisualizacao;
